<template>
  <div id="calculate-chart" :style="{ width: width + 'px', height: height + 'px' }"></div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/component/tooltip");

export default {
  name: "calculate-chart",
  props: {
    series_type: String,
    time_data: Array,
    volume_data: Object,
    width: Number,
    height: Number,
    is_loading: Boolean,
  },
  data() {
    return {
      chart: {},
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
    series_type() {
      this.chart.showLoading();
      this.draw();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("calculate-chart"));
    this.chart.showLoading();
    this.draw();
  },
  computed: {},
  methods: {
    draw() {
      const _this = this;
      const data = _this.volume_data;
      if (null == data || "undefined" == typeof data || "" == data) {
        this.chart.hideLoading();
        this.chart.setOption(
          { xAxis: { type: "category", data: ["暂无数据"] }, yAxis: { type: "value" } },
          true
        );
        return;
      }

      var option = {
        xAxis: {
          type: "category",
          data: _this.time_data,
          axisTick: {
            show: _this.series_type === "line" ? true : false,
          },
        },
        yAxis: {
          type: "value",
          name: "（元）",
          nameTextStyle: {
            color: "#999999",
          },
          axisLine: {
            lineStyle: {
              color: "#DDDDDD",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#333333",
            },
          },
        },
        series: [
          {
            data: data.value,
            type: _this.series_type,
            smooth: true,
            itemStyle: {
              color: "#00578F",
            },
            barWidth: 20,
          },
        ],
        tooltip: {
          axisPointer: {
            type: _this.series_type === "line" ? "line" : "shadow",
          },
          trigger: "axis",
          formatter: function (params) {
            let date = params[0].name;
            let index = _this.time_data.lastIndexOf(Number(date));
            return data.value[index]
              ? `产值：${data.value[index]}元<br/>
              年份：${date}年<br/>
              项目单年出货量：${data.shipment[index]}件<br/>
              项目零件数量：${data.partsNum[index]}件<br/>
              用户企业份额占比：${data.share[index]}%<br/>
              单产品销售价格：${data.price[index]}元<br/>
              `
              : ``;
          },
        },
      };

      this.chart.clear();
      this.chart.setOption(option, true);
      this.chart.hideLoading();
    },
  },
};
</script>
